
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 23","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.852.501C4.316 1.077 0 5.769 0 11.471c0 6.092 4.925 11.03 11 11.03s11-4.938 11-11.03c0-5.704-4.319-10.397-9.857-10.97v2.362c4.242.561 7.517 4.201 7.517 8.608 0 4.796-3.877 8.683-8.66 8.683s-8.66-3.887-8.66-8.683c0-4.405 3.272-8.044 7.512-8.607V.501z","fill":"#0C0D0E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.262 16.156a7.322 7.322 0 009.367 1.742c3.508-2.03 4.71-6.528 2.685-10.045A7.323 7.323 0 007.296 5.162c-3.17 1.835-4.457 5.684-3.18 9.004l2.086-1.208A4.989 4.989 0 018.48 7.216a4.96 4.96 0 016.786 1.823 4.988 4.988 0 01-1.819 6.805 4.96 4.96 0 01-6.098-.896l-2.086 1.208z","fill":"#0C0D0E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.781 8.002a3.677 3.677 0 00-2.445 3.467 3.672 3.672 0 003.667 3.677 3.672 3.672 0 003.666-3.677c0-1.599-1.018-2.96-2.44-3.465v3.467h-.004c0 .676-.548 1.224-1.222 1.224a1.224 1.224 0 01-1.222-1.272V8.002z","fill":"#0C0D0E"}})])
          )
        }
      }
    